import "@/App.css";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { api } from "@/lib/api";
import { RouteMeta } from "@/lib/seo";
import { BackToTop } from "@/components/BackToTop";
import { MotionConfig } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { A11yProvider, useA11y } from "@/context/A11yContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import QuickStart from "@/pages/QuickStartPage";
import ResourceCentre from "@/pages/ResourceCentre";
import Workspace from "@/pages/Workspace";
import Poster from "@/pages/PosterPage";
import ResetPassword from "@/pages/ResetPassword";
import Privacy from "@/pages/Privacy";
import WorkbookPage from "@/pages/WorkbookPage";
import Toolkit3Page from "@/pages/Toolkit3Page";
import Toolkit4Page from "@/pages/Toolkit4Page";
import PrintablesPage from "@/pages/PrintablesPage";
import { FeedbackPage, ImpactPage, ResourcesPage, ContactPage, AccessibilityPage, DisclaimerPage, FuturePage } from "@/pages/PublicPages";
import { WorkspaceProvider } from "@/context/WorkspaceContext";

const VisitTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (/^\/(admin|workspace)/.test(pathname)) return;
    api.post("/visits", { path: pathname.slice(0, 120) }).catch(() => {});
  }, [pathname]);
  return null;
};

const Shell = () => {
  const { settings } = useA11y();
  return (
    <MotionConfig reducedMotion={settings.reduceMotion ? "always" : "user"}>
      <SmoothScroll />
      <BrowserRouter>
        <VisitTracker />
        <RouteMeta />
        <BackToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/quick-start" element={<QuickStart />} />
          <Route path="/resource-centre" element={<ResourceCentre />} />
          <Route path="/workspace" element={<Workspace />} />
          <Route path="/poster" element={<Poster />} />
          <Route path="/workspace/reset" element={<ResetPassword />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/workbook" element={<WorkbookPage />} />
          <Route path="/toolkit-3" element={<Toolkit3Page />} />
          <Route path="/toolkit-4" element={<Toolkit4Page />} />
          <Route path="/printables" element={<PrintablesPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/impact-review" element={<ImpactPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/accessibility" element={<AccessibilityPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          <Route path="/future" element={<FuturePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" />
    </MotionConfig>
  );
};

function App() {
  return (
    <div className="App">
      <A11yProvider>
        <WorkspaceProvider>
          <Shell />
        </WorkspaceProvider>
      </A11yProvider>
    </div>
  );
}

export default App;
